export const TEA_APP_ID = {
  CN: 1880,
  VA: 441507,
};
